import { IState } from 'shared/store';

import { IPurchaseTerms } from '../../types/purchaseTerm/purchaseTerm';

export const selectPurchaseTerms = (state: IState): IPurchaseTerms | null | undefined => {
  return state.offerData.pricesDialog;
};
